import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { setPortal } from 'modules/portal';
import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { NewMediaMcStatistics } from 'lib/api/media';

import FilterWrap from 'components/atoms/FilterWrap';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import TableContainer from 'components/molecules/MbTable';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

let initialization = false;
let initParam = {};
const Statistics = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));

  // 공통 필터에서 초기값 받아왔는지 확인
  const [getInitParam, setGetInitParam] = useState(false);
  const [params, setParams] = useState(initParam);

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  // header 및 body 컬럼 커스텀
  const customized = {
    // 사이트명
    SITE_NAME: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'SITE_NAME').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const statsSiteName = getHeadObj(headsMap, 'SITE_NAME');
        const showWindowUrl =
          '/report/daily/targeting?sDate=' +
          params.sDate +
          '&eDate=' +
          params.eDate +
          '&mediaId=' +
          rowObj.MEDIA_ID +
          '&mediaScriptNo=' +
          rowObj.MEDIA_SCRIPT_NO +
          '&isPop=1';

        let resultComponent = (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['SITE_NAME'],
              statsSiteName.type,
              statsSiteName.format
            )}
            icon={rowObj['CORP_NAME'] !== 'total' && 'faExternalLink'}
            toolTipTitle={t('해당 날짜의 지면별 타게팅분포')}
            onClick={(e) => handlePortalUrl(showWindowUrl)}
          />
        );

        return resultComponent;
      },
    },
    // 클릭수
    CLICK_CNT: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'CLICK_CNT').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const statsClickCnt = getHeadObj(headsMap, 'CLICK_CNT');
        const showWindowUrl =
          '/report/adver/detail?sDate=' +
          params.sDate +
          '&eDate=' +
          params.eDate +
          '&mediaScriptNo=' +
          rowObj.MEDIA_SCRIPT_NO +
          '&isPop=1';

        let resultComponent = (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['CLICK_CNT'],
              statsClickCnt.type,
              statsClickCnt.format
            )}
            icon={rowObj['CORP_NAME'] !== 'total' && 'faExternalLink'}
            toolTipTitle={t('해당 날짜의 지면별 타게팅분포')}
            onClick={(e) => handlePortalUrl(showWindowUrl)}
          />
        );

        return resultComponent;
      },
    },
    // 전환수
    ORDER_CNT: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'ORDER_CNT').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const statsClickCnt = getHeadObj(headsMap, 'ORDER_CNT');
        const showWindowUrl =
          '/report/conversion/state_list?sDate=' +
          params.sDate +
          '&eDate=' +
          params.eDate +
          '&mediaId=' +
          rowObj.MEDIA_ID +
          '&isPop=1';

        let resultComponent = (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['ORDER_CNT'],
              statsClickCnt.type,
              statsClickCnt.format
            )}
            icon={rowObj['CORP_NAME'] !== 'total' && 'faExternalLink'}
            toolTipTitle={t('해당 날짜의 지면별 타게팅분포')}
            onClick={(e) => handlePortalUrl(showWindowUrl)}
          />
        );

        return resultComponent;
      },
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const getParam = (newParams) => {
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }
    setGetInitParam(true);
    setParams({
      ...params,
      ...newParams,
    });
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initData={initParam}
          initialization={initialization}
          getParam={getParam}
        />
      </FilterWrap>
      {getInitParam && (
        <TableContainer
          dataReqPromise={NewMediaMcStatistics}
          params={{ ...params }}
          sort="desc"
          order="ADVRTS_AMT"
          dense={true}
          hasExcel
          hasTotal
          customized={customized}
        />
      )}
    </>
  );
};

export default Statistics;
